export { default } from "./src/personalization-container";
export type { UniformPersonalizationContainerProps } from "./src/personalization-container";
